import { render, staticRenderFns } from "./ReferralActionModal.vue?vue&type=template&id=516a5662&"
import script from "./ReferralActionModal.vue?vue&type=script&lang=js&"
export * from "./ReferralActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports